import * as React from "react";
const SvgFiRrWheelchair = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-wheelchair_svg__a)">
      <path
        fill="#062147"
        d="M23 21h-1.279l-1.32-3.949a3 3 0 0 0-2.842-2.05H14a2 2 0 0 1-2-2h6a1 1 0 0 0 0-2h-6V8a1 1 0 0 0-.027-.135 4 4 0 1 0-1.946 0A1 1 0 0 0 10 8v5a4 4 0 0 0 3.911 3.991 6 6 0 1 1-6.769-6.929 1 1 0 0 0-.284-1.98A8 8 0 1 0 15.931 17h1.628a1 1 0 0 1 .95.684l1.543 4.632A1 1 0 0 0 21 23h2a1 1 0 0 0 0-2M9 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-wheelchair_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrWheelchair;
